const TahunAjaranSearch = {
    kodeTahunAjaran: null,
    status: null
}

export default TahunAjaranSearch;